import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import { VisualizationContext } from '../../../../ContextProviders/VisualizationProvider';
import { InteractionStarted } from '../../../../../Visualization/EventTypes';
import { BACK, FRONT, LEFT, RIGHT, TOP } from '../../../../../Constants/CameraViews';
import { ToolbarButtonWithSubmenu } from '../../ToolbarButtonWithSubmenu';
import { ToolbarButton } from '../../ToolbarButton';

import viewIconSrc from './icons/view.svg';
import viewIconActiveSrc from './icons/view-active.svg';
import cameraLeftIconSrc from './icons/camera_left.svg';
import cameraLeftIconActiveSrc from './icons/camera_left-active.svg';
import cameraRightIconSrc from './icons/camera_right.svg';
import cameraRightIconActiveSrc from './icons/camera_right-active.svg';
import cameraFrontIconSrc from './icons/camera_front.svg';
import cameraFrontIconActiveSrc from './icons/camera_front-active.svg';
import cameraBackIconSrc from './icons/camera_back.svg';
import cameraBackIconActiveSrc from './icons/camera_back-active.svg';
import cameraTopIconSrc from './icons/camera_top.svg';
import cameraTopIconActiveSrc from './icons/camera_top-active.svg';

const ViewButton = () => {
  const visualization = useContext(VisualizationContext);
  const { t } = useTranslation();
  const [active, setActive] = useState();
  useEffect(() => {
    if (active) {
      return visualization.on(InteractionStarted, () => setActive(false));
    }
  }, [active, visualization]);

  const createClickHandler = (side) => () => visualization.controls.fixedViews.moveTo(side) + setActive(side);

  return (
    <ToolbarButtonWithSubmenu
      iconSrc={viewIconSrc}
      activeIconSrc={viewIconActiveSrc}
      title={t('cameraViews.title')}
    >
      <Grid container spacing={3}>
        <Grid item>
          <ToolbarButton
            iconSrc={cameraLeftIconSrc}
            activeIconSrc={cameraLeftIconActiveSrc}
            onClick={createClickHandler(LEFT)}
            label={t('cameraViews.left')}
            active={active === LEFT}
          />
        </Grid>
        <Grid item>
          <ToolbarButton
            iconSrc={cameraRightIconSrc}
            activeIconSrc={cameraRightIconActiveSrc}
            onClick={createClickHandler(RIGHT)}
            label={t('cameraViews.right')}
            active={active === RIGHT}
          />
        </Grid>
        <Grid item>
          <ToolbarButton
            iconSrc={cameraFrontIconSrc}
            activeIconSrc={cameraFrontIconActiveSrc}
            onClick={createClickHandler(FRONT)}
            label={t('cameraViews.front')}
            active={active === FRONT}
          />
        </Grid>
        <Grid item>
          <ToolbarButton
            iconSrc={cameraBackIconSrc}
            activeIconSrc={cameraBackIconActiveSrc}
            onClick={createClickHandler(BACK)}
            label={t('cameraViews.back')}
            active={active === BACK}
          />
        </Grid>
        <Grid item>
          <ToolbarButton
            iconSrc={cameraTopIconSrc}
            activeIconSrc={cameraTopIconActiveSrc}
            onClick={createClickHandler(TOP)}
            label={t('cameraViews.top')}
            active={active === TOP}
          />
        </Grid>
      </Grid>
    </ToolbarButtonWithSubmenu>
  );
};

export default ViewButton;
